export class AppSettings {
    static systemConfiguration = {} as NPS.Common.Branding.ISystemConfiguration;
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/AppSettings.ts